<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <v-card
      flat
      :loading="loading"
    >
      <v-card-title>
        Add snippet
        <v-spacer />
        <v-icon @click="dialog = false"> close </v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="mt-6">
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="type"
                outlined
                :items="types"
                :rules="[$rules.required]"
                label="Snippet Type"
              />
            </v-col>
            <template v-if="type == 'list'">
              <v-col cols="12">
                <v-autocomplete
                  v-model="snippet.categoryId"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  label="Category"
                  outlined
                  clearable
                  hide-details
                />
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="snippet.industryId"
                  :items="industries"
                  item-text="name"
                  item-value="id"
                  label="Industry"
                  outlined
                  clearable
                  hide-details
                  :disabled="isParentCategory"
                />
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="snippet.topicId"
                  :items="topics"
                  item-text="name"
                  item-value="id"
                  label="Topic"
                  outlined
                  clearable
                  hide-details
                  :disabled="!snippet.industryId || isParentCategory"
                />
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="snippet.designGroupId"
                  :items="designGroupsByIndustryOrTopic(snippet.industryId, snippet.topicId)"
                  item-text="name"
                  item-value="id"
                  label="Design Group"
                  outlined
                  clearable
                  hide-details
                  :disabled="!snippet.industryId || isParentCategory"
                />
              </v-col>
            </template>
            <v-col
              v-if="type == 'single'"
              cols="12"
            >
              <v-text-field
                v-model="snippet.templateId"
                label="Template Id"
                :rules="[$rules.required]"
                outlined
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12">
              <v-btn
                color="primary"
                large
                :loading="saving"
                class="mr-2"
                @click="save"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
export default {
  name: 'SnippetDialog',

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      dialog: false,
      snippet: {},
      type: null,
      types: ['list', 'single', 'direct_mail']
    };
  },

  computed: {
    topics() {
      if (this.snippet.industryId) {
        return this.topicsByIndustry(this.snippet.industryId);
      }
      return [];
    },
    isParentCategory() {
      return !!this.categories.filter((x) => x.parentCategoryId === this.snippet.categoryId).length;
    },
    ...mapGetters({
      topicsByIndustry: 'lookup/topicsByIndustry',
      all_topics: 'lookup/topics',
      categories: 'lookup/categories',
      industries: 'lookup/industries',
      designGroupsByIndustryOrTopic: 'lookup/designGroupsByIndustryOrTopic'
    })
  },

  watch: {
    type(val, oldVal) {
      if (val !== oldVal && oldVal) {
        this.snippet = {};
      }
    }
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.EDIT_SNIPPET_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.EDIT_SNIPPET_SHOW, (data) => {
      this.type = data.templateId ? 'single' : 'list';
      if (data.topicId && !data.industryId) {
        data.industryId = this.all_topics
          .filter((x) => x.id === data.topicId)
          .map((x) => x.industryId)[0];
      }
      this.snippet = cloneDeep(data);
      if (this.snippet.topicId && !this.snippet.industryId) {
        this.$set(
          this.snippet,
          'industryId',
          this.all_topics.filter((x) => x.id === this.snippet.topicId).map((x) => x.industryId)[0]
        );
      }
      this.dialog = true;
    });
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.$emit('save', Object.assign(this.snippet, { type: this.type }));
      this.dialog = false;
    }
  }
};
</script>
